

















import { defineComponent, toRef } from "@vue/composition-api";
import useModal from "@/hooks/useModal";
import BaseIcon from "@/components/Base/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import PageMore from "@/views/PageMore";

export default defineComponent({
  name: "NavigationMore",
  components: { PageMore, BaseIcon, CustomScroll },
  props: {
    show: { type: Boolean, required: true },
    leftPosition: { type: Boolean },
  },
  setup(props) {
    const { modalClose } = useModal(toRef(props, "show"), true);
    return { modalClose };
  },
  watch: {
    $route() {
      this.$emit("input");
    },
  },
});
